<script lang="ts" setup>
import {
  MateCardFactoryGenerateType,
  MateCardPromptType,
} from "@/enums/chatEnums";
import { createOneCardPrompt } from "@/apis/chat";
import { GenerateMateContext } from "@/types/chat";
import { showFailToast } from "vant";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const GenerateTypeOptions: {
  label: string;
  value: MateCardFactoryGenerateType;
}[] = [
  {
    label: "Message.textGeneration.overwrite",
    value: MateCardFactoryGenerateType.Overwrite,
  },
  {
    label: "Message.textGeneration.continue",
    value: MateCardFactoryGenerateType.Continue,
  },
];

const props = withDefaults(
  defineProps<{
    inspireTxt?: string;
    modelValue?: string;
    generating: boolean;
    promptType: MateCardPromptType;
    isUniversal?: boolean;
    generateType?: MateCardFactoryGenerateType;
    mateContext?: GenerateMateContext;
    from?: number | null;
    to?: number | null;
    chatSceneName?: string;
    chatSceneDescription?: string;
    name?: string;
    componentType?: string;
  }>(),
  {
    isUniversal: false,
    modelValue: "",
    generateType: MateCardFactoryGenerateType.Overwrite,
    mateContext: () => ({}),
    from: 0,
    to: 0,
  }
);
const emit = defineEmits<{
  (e: "update:modelValue", val: string): void;
  (e: "update:generating", val: boolean): void;
  (e: "update:generateType", val: MateCardFactoryGenerateType): void;
}>();

const onGenerateClick = async () => {
  try {
    if (props.componentType === "targetReaction") {
      if (!props.chatSceneName)
        return showFailToast(t("Message.pleaseFillChatSceneName"));

      if (!props.chatSceneDescription)
        return showFailToast(t("Message.pleaseFillChatSceneDescription"));

      if (!props.name)
        return showFailToast(t("Message.pleaseFillReactionName"));
      const { from, to } = props;
      if (from && to && from > to)
        return showFailToast(t("Message.reactionNumberError"));
    }
    emit("update:generating", true);
    const { data } = await createOneCardPrompt({
      text:
        props.generateType === MateCardFactoryGenerateType.Continue
          ? props.modelValue
          : props.inspireTxt
          ? props.inspireTxt
          : undefined,
      isUniversal: props.isUniversal,
      method: props.promptType,
      type: props.generateType,
      mate: props.mateContext,
      from: props.from,
      to: props.to,
      chatSceneName: props.chatSceneName,
      chatSceneDescription: props.chatSceneDescription,
      name: props.name,
    });
    if (props.generateType === MateCardFactoryGenerateType.Continue) {
      emit("update:modelValue", `${props.modelValue}${data.text}`);
    } else {
      emit("update:modelValue", data.text);
    }
  } finally {
    emit("update:generating", false);
  }
};
</script>
<template>
  <div class="flex gap-2">
    <SingleSelect
      :options="GenerateTypeOptions"
      :selected="generateType"
      class="flex-1"
      select-class="btn-xs sm:btn-sm rounded   flex-grow w-full flex-nowrap"
      @update:selected="emit('update:generateType', $event)"
    />
    <button
      :disabled="generating"
      class="btn btn-neutral btn-xs rounded sm:btn-sm"
      @click="onGenerateClick"
    >
      <i class="iconify mingcute--quill-pen-line" />
      <span v-if="generating" class="loading loading-xs" />
      <span v-else>
        {{ $t("Message.textGeneration.generate") }}
      </span>
    </button>
  </div>
</template>
